<template>
  <v-card>
    <v-card-title>
      Category Materials
      <v-spacer />
    </v-card-title>
    <v-divider />
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      disable-pagination
      hide-default-footer
      mobile-breakpoint="0"
      show-expand
      group-by="category.name"
      item-key="tempId"
    >
      <template #[`group.header`]="{ items, isOpen, toggle }">
        <th colspan="100%">
          <v-icon @click="toggle">
            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
          </v-icon>
          {{ items[0].category.name }}
        </th>
      </template>
      <template #[`item.text`]="{ item }">
        <v-text-field
          v-model="item.text"
          outlined
          dense
          maxlength="100"
          hide-details="auto"
          @blur="saveName(item)"
        />
      </template>
      <template #[`item.description`]="{ item }">
        <v-icon :color="item.description ? 'success' : 'error'">
          {{ item.description ? 'check_circle' : 'cancel' }}
        </v-icon>
      </template>

      <template #expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-textarea
            v-model="item.description"
            outlined
            label="Description"
            dense
            class="my-2 white"
            hide-details="auto"
            @blur="saveName(item)"
          >
          </v-textarea>
          <MaterialTraits
            class="my-2"
            :material="item.material"
            :category-id="item.category.id"
          />
        </td>
      </template>
    </v-data-table>
    <LoadingSpinnerDialog :loading="loading_dialog" />
  </v-card>
</template>

<script>
import MaterialTraits from '@/components/print/MaterialTraits';
import { sortBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  components: { MaterialTraits },
  props: {},
  data: () => ({
    loading: true,
    loading_dialog: false,
    groupId: null,
    headers: [
      { text: 'Category', value: 'category.name' },
      { text: 'Material', value: 'material.name' },
      { text: 'Override Name', value: 'text' },
      { text: 'Desc', value: 'description' },
      { text: 'Base', value: 'baseTraits' },
      { text: 'Traits', value: 'traits' }
    ]
  }),
  computed: {
    items() {
      return sortBy(this.category_materials, ['category.name', 'material.name', 'text']);
    },
    ...mapGetters({
      category_materials: 'print/category_materials'
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('print/getLookups')
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveName(item) {
      this.savingName = true;
      this.$store
        .dispatch('print/saveMaterialName', {
          materialId: item.material.id,
          categoryId: item.category.id,
          text: item.text,
          description: item.description
        })
        .then(() => {
          this.$root.$snackbarSuccess('Material name saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingName = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin-top: 0 !important;
}
</style>
